<template>
	<div class="auth">
		<aside class="auth__brand">
			<b-img
				class="auth__logo"
				:src="require(`@/assets/${$root.scope}/logo_area_pubblica_reg.png`)"
				alt="logo app"
			></b-img>
		</aside>

		<main class="auth__panel">
			<b-overlay
				:show="status.loggingIn || $route.query.access_token !== undefined"
				spinner-variant="secondary"
				rounded="lg"
				class="auth__card"
			>
				<b-form @submit.prevent="onSubmit">
					<h1 class="auth__title">{{ $t('accedi') }}</h1>
					<p class="auth__lead">{{ $t('benvenuto') }}</p>

					<b-form-group :label="$t('email')" label-for="login-email">
						<b-form-input
							id="login-email"
							name="email"
							type="text"
							v-model="form.username"
							:placeholder="$t('placeholder_email')"
							autocomplete="username"
							required
						></b-form-input>
					</b-form-group>

					<b-form-group :label="$t('password')" label-for="login-password">
						<div class="auth__field">
							<b-form-input
								id="login-password"
								name="password"
								:type="passwordClear ? 'text' : 'password'"
								v-model="form.password"
								:placeholder="$t('placeholder_password')"
								autocomplete="current-password"
								class="pr-5"
								required
							></b-form-input>
							<b-icon
								:icon="passwordClear ? 'eye' : 'eye-slash'"
								font-scale="1.2"
								class="auth__eye"
								@click="passwordClear = !passwordClear"
								@keydown.enter.prevent="passwordClear = !passwordClear"
								@keydown.space.prevent="passwordClear = !passwordClear"
								role="button"
								tabindex="0"
								:aria-label="passwordClear ? $t('LoginPage.hide_password') : $t('LoginPage.show_password')"
							></b-icon>
						</div>
					</b-form-group>

					<div class="text-right">
						<span
							class="auth__forgot"
							@click="$router.push({ name: 'recupero password' })"
							@keydown.enter.prevent="$router.push({ name: 'recupero password' })"
							role="button"
							tabindex="0"
						>
							{{ $t('dimenticato_password') }}
						</span>
					</div>

					<p v-if="status.loggedIn == false" class="auth__error" role="alert">
						{{ $t('credenziali_errate') }}
					</p>

					<div class="auth__actions">
						<b-button type="submit" variant="secondary" block>
							{{ $t('accedi') }}
						</b-button>
						<div class="auth__sso" v-if="showSpidButton || showCieButton">
							<b-button v-if="showSpidButton" variant="outline-secondary" @click="goToSpidLogin">
								{{ $t('LoginPage.enter_with_spid') }}
							</b-button>
							<b-button v-if="showCieButton" variant="outline-secondary" @click="goToCieLogin">
								{{ $t('LoginPage.enter_with_cie') }}
							</b-button>
						</div>
					</div>

					<div class="auth__divider"><span>{{ $t('oppure') }}</span></div>
					<b-button variant="popup-button" block @click="$router.push('/register')">
						{{ $t('registrati') }}
					</b-button>

					<div class="auth__footer" v-if="$root.scope === 'concura'">
						<span>{{ $t('hai_bisogno_aiuto') }}</span>
						<span
							@click="callSupport"
							@keydown.enter.prevent="callSupport"
							@keydown.space.prevent="callSupport"
							class="auth__support"
							role="button"
							tabindex="0"
							:aria-label="$t('LoginPage.call_support')"
						>
							<b-icon icon="telephone-fill" aria-hidden="true"></b-icon>
							<span id="login-phone-number">{{ $t('numero_supporto') }}</span>
						</span>
					</div>
				</b-form>
			</b-overlay>

			<b-modal id="modal-1" :title="$t('recupera_password')" hide-footer centered>
				<p class="text-left">
					{{ $t('testo_recupera_password') }}
				</p>
				<b-form-input
					class="my-3"
					name="email"
					type="email"
					v-model="recoverEmail"
					:placeholder="$t('placeholder_inserisci_email')"
					:aria-label="$t('placeholder_inserisci_email')"
					required
				></b-form-input>

				<div class="col-12 text-center">
					<p v-if="status.recoverSent === true">
						{{ $t('mail_inviata') }}
					</p>
					<p v-else-if="status.recoverSent === false" class="text-danger">
						{{ $t('email_non_valida') }}
					</p>
					<b-button
						:disabled="!canSubmit"
						@click="submitRecover"
						type="button"
						variant="secondary mt-2 mx-auto col-lg-4 col-sm-7"
					>
						{{ $t('invia') }}
					</b-button>
				</div>
				<br />
			</b-modal>
		</main>

		<CallMailSupportButtons v-if="showButtons"></CallMailSupportButtons>
	</div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import CallMailSupportButtons from "@/app/layout/components/CallMailSupportButtons.vue";
export default {
	name: "LoginPage",
	components: { CallMailSupportButtons },
	data() {
		return {
			form: {
				// email: null,
				username: null,
				password: null,
			},
			recoverEmail: null,
			canSubmit: false,
			bgStyle: {
				backgroundImage: `url(${require("@/assets/concura/login_img.svg")})`,
				backgroundPosition: "3vw bottom",
				backgroundSize: "80vh",
				backgroundRepeat: "no-repeat",
				minHeight: "90vh",
			},
			passwordClear: false,
			showButtons: process.env.VUE_APP_CALLUSBTN_ENABLED,
		};
	},
	computed: {
		...mapState("utente", ["status", "user"]),
		showSpidButton() {
			return (
				process.env.VUE_APP_ENABLE_SPID?.toLowerCase() === "true"
			);
		},
		showCieButton() {
			return (
				process.env.VUE_APP_ENABLE_CIE?.toLowerCase() === "true"
			);
		},
		isDemoEnvironment() {
			return process.env.VUE_APP_IS_DEMO?.toLowerCase() === "true";
		},
	},
	methods: {
		...mapActions("utente", ["login", "logout", "recoverPassword", "me"]),
		...mapActions({
			infoAlert: "alert/info",
			clearAlert: "alert/clear",
		}),
		onSubmit() {
			// console.log(this.status);
			if (this.form) {
				this.login(this.form)
					.then((res) => {
						// console.log("after login ok", res);
					})
					.catch((error) => {
						console.log("after login error", error);
					});
			}
		},
		submitRecover() {
			this.recoverPassword({ email: this.recoverEmail })
				.then((res) => {
					this.$root.$emit("bv::hide::modal", "modal-1");
				})
				.catch((error) => {
					// this.$root.$emit("bv::hide::modal", "modal-1");
				});
		},
		goToSpidLogin() {
			if (this.isDemoEnvironment) {
				this.infoAlert(this.$t('alert_demo_cie_spid'));
				setTimeout(() => {
					this.clearAlert();
				}, 3000);
				return;
			}
			const spidUrl = process.env.VUE_APP_SPID_LOGIN_URL;
			window.location.href = spidUrl;
		},
		goToCieLogin() {
			if (this.isDemoEnvironment) {
				this.infoAlert(this.$t('alert_demo_cie_spid'));
				setTimeout(() => {
					this.clearAlert();
				}, 3000);
				return;
			}
			const cieUrl = process.env.VUE_APP_CIE_LOGIN_URL;
			window.location.href = cieUrl;
		},
		callSupport() {
			window.location.href = "tel:800770272";
		},
	},
	watch: {
		recoverEmail(val) {
			this.canSubmit = val !== null && val.indexOf("@") > 1;
		},
	},
	mounted() {
		if (this.$route.query.access_token) {
			var self = this;
			this.me(this.$route.query.access_token);
			// .then(function () {
			// self.$router.push({ name: "Home" });
			// });
		}
	},
};
</script>

